import Vue from 'vue';

export default {
  async paraNumero(data) {
    if (data) {
      const dataSplit = data.split('/');
      const dateToInt = dataSplit[2] + '-' + dataSplit[1] + '-' + dataSplit[0];

      const date = await Vue.http
        .get('/api/utils/ConversaoDateToInt', {
          params: {
            dateToInt
          }
        })
          .then(response => response.body)
          .catch(() => 0);

      return date;
    }

    return 0;
  },
  paraData(numero, valorPadrao = '') {
    if (numero) {
      return moment("1899-12-30").add(numero, 'days').format('DD/MM/YYYY');
    }

    return valorPadrao;
  },
  dataParaStr(data, retornarSeVazio = '') {
    if (data) {
      return moment(String(data)).format('DD/MM/YYYY');
    }

    return data || retornarSeVazio;
  },
  formatarHora(data, retornarSeVazio = '') {
    if (data) {
      return moment(String(data)).format('HH:mm:ss');
    }

    return data || retornarSeVazio;
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/js/formatar-data.js